import React from 'react'
import Numeral from 'numeral'
import 'numeral/locales/fr'
import { FormatPriceProps } from './Type'
import { FormatPriceAsString } from './Utils'

Numeral.locale('fr')

const Price: React.FC<FormatPriceProps> = ({
  price,
  format,
  removeCurrency,
  currencySuffix,
}): React.ReactElement => {
  return (
    <>
      {FormatPriceAsString({
        price,
        format,
        removeCurrency,
        currencySuffix,
      })}
    </>
  )
}

export default Price
